export const DonationFormLayouts = {
  IFrame: 'iframe',
  Platform: 'platform',
} as const

export type DonationFormLayouts = (typeof DonationFormLayouts)[keyof typeof DonationFormLayouts]
